import { Layout, Menu } from "antd";
import React from "react";
import { useState, useEffect , useRef } from "react";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  ToolFilled,
  WindowsFilled,
  GitlabFilled,
  InteractionFilled,
  BankFilled,
  FundFilled,
  FileZipFilled,CodeSandboxCircleFilled
} from "@ant-design/icons";
import "../css/navbar.css";
import"../css/report.css";
import axios from "axios";
import { path, src } from "../network/conn";
import Logo from "../images/feenixlogo.png";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../component/dashboard";
import Masterexpense from "./expense";
import Masterpayment from "./payment";
import Masterscan from "./scanitem";
import Scanentry from "./scanentry";
import ExpenseEntry from "./expenseentry";
import Masteremployee from "./masteremployee";
import Scanstatus from "./scanstatus";
import MasterProfile from "./profile";
import Invoicereport from "./report";
import Invoicereportacc from "./reportacc";
import Paymentreport from "./paymentreport";
import Expensereport from "./expensereport";
const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
function Navbar() {
  const userName = window.sessionStorage.getItem("user");
  const profile = window.sessionStorage.getItem("profile");
  const navigate = useNavigate();
  const [collapsed, setcollapsed] = useState(false);
  const [permissionSet,setPermissionSet] = useState({});
  const handleScanStatusReload = useRef();
  const toggle = () => {
    setcollapsed(!collapsed);
    console.log(collapsed);
  };
  const sessionLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };
  const Logout = () => {
    if (userName == null) {
      sessionLogout();
    }
  };
  const handleScanDataReload = () =>{  
    console.log('reloaded');  
    console.log('reloadData',handleScanStatusReload);
    handleScanStatusReload.current.handlePropsReload();
    console.log('reloadedOut');  
     }
     const handleShowChanged = () =>{
      fetch_profile_permission(profile);
     }
     const fetch_profile_permission = (profile) =>{
      console.log('profile',profile);
      let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
      axios
      .get(BaseURL)
        .then((response) => {
          console.log(response.data);
          let dataObj = {};
          response.data.map((list)=>{
            let permissionObj = {};
            permissionObj['add']      = list.add;
            permissionObj['edit']     = list.edit;
            permissionObj['delete']   = list.delete;
            permissionObj['show']     = list.show;
            permissionObj['print']    = list.print;
            permissionObj['excel']    = list.excel;
            permissionObj['profile']  = list.profile;
            dataObj[list.filename]    =  permissionObj;
          })
         setPermissionSet(dataObj);
         console.log('dataObj',dataObj);
        })
        .catch((error) => {
          //openMessageSuccess(error, 10);
          console.log(error);
        });
    }
  useEffect(() => {
    Logout();
    fetch_profile_permission(profile);
  }, []);
  return (
    <div>
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          className="completeSider"
        >
          <div className="logo">
            <Link to="dashboard">
              {!collapsed?<h2>Feenix App</h2>:<img src={Logo} height="100%" width="100%"></img>}
            </Link>
          </div>
          

              <Menu theme="dark" mode="inline" className="navMenus">
              <SubMenu icon={<WindowsFilled />} title="Masters" className="menus">
               {permissionSet['masterexpense']?.show == 1 ? <Menu.Item key="1" className="menus">
                 <Link to="masterexpense">Expense </Link>
               </Menu.Item> : ''}
               {permissionSet['masterpayment']?.show == 1 ?  <Menu.Item key="2" className="menus">
                 <Link to="masterpayment">Payment </Link>
               </Menu.Item> : '' }
               {permissionSet['masterscan']?.show == 1 ?  <Menu.Item key="3" className="menus">
                 <Link to="masterscan">Scan </Link>
               </Menu.Item> : '' }
              {permissionSet['masteremployee']?.show == 1 ?  <Menu.Item key="8" className="menus">
                 <Link to="masteremployee">Employee </Link>
               </Menu.Item> : '' }
               {permissionSet['masterprofile']?.show == 1 ?  <Menu.Item key="15" className="menus">
                 <Link to="masterprofile">Profile</Link>
               </Menu.Item> : '' }
             </SubMenu>
             {permissionSet['scanentry']?.show == 1 ?   <Menu.Item key="4" className="menusSub"  icon={<GitlabFilled />} >
                <Link to="scanentry">Scan Entry</Link> 
               </Menu.Item> : '' }
               {permissionSet['scanstatus']?.show == 1 ?  <Menu.Item key="5" className="menusSub"  icon={<InteractionFilled />} >
                <Link to="scanstatus">Scan Status</Link> 
               </Menu.Item> : '' }
               {permissionSet['expenseentry']?.show == 1 ?  <Menu.Item key="7" className="menusSub"  icon={<BankFilled />} >
                <Link to="expenseentry">Expense Entry</Link> 
               </Menu.Item> : '' }
             <SubMenu icon={<FileZipFilled />} title="Reports" className="menus">
             {permissionSet['statementreport']?.show == 1 ?  <Menu.Item key="26" className="menus">
                <Link to="report">Statement report</Link> 
               </Menu.Item> : '' }
               {permissionSet['paymentreport']?.show == 1 ?   <Menu.Item key="27" className="menus">
                <Link to="paymentreport">Payment Report</Link> 
               </Menu.Item> : '' }
               {permissionSet['invoicereport']?.show == 1 ?  <Menu.Item key="28" className="menus">
                <Link to="invoicereport">Invoice Report</Link> 
               </Menu.Item> : '' }
               {permissionSet['expensereport']?.show == 1 ?  <Menu.Item key="29" className="menus">
                <Link to="expensereport">Expense Report</Link> 
               </Menu.Item> : '' }
             </SubMenu>
           </Menu>
          
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background">
            <span onClick={toggle} className="trigger">
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </span>
            <span className="logout" onClick={sessionLogout}>
              {<LogoutOutlined />}
              &nbsp;
              {userName}
            </span>
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: "24px 16px",
              padding: 24,
              height: `82vh`,
            }}
          >
            <Routes>
              <Route path="dashboard" element={<Dashboard/>}></Route>
               <Route path="masterexpense" element={<Masterexpense data={permissionSet['masterexpense'] ? permissionSet['masterexpense'] : {} }/>}></Route> 
              <Route path="masterpayment" element={<Masterpayment data={permissionSet['masterpayment']}/>}></Route> 
              <Route path="masterscan" element={<Masterscan data={permissionSet['masterscan']}/>}></Route> 
              <Route path="scanentry" element={<Scanentry onScanDataRefresh = {handleScanDataReload} scan={permissionSet['scanentry']} doctor={permissionSet['masterdoctor']} patient={permissionSet['masterpatient']} />}></Route> 
              <Route path="expenseentry" element={<ExpenseEntry data={permissionSet['expenseentry']}/>}></Route> 
              <Route path="masteremployee" element={<Masteremployee data={permissionSet['masteremployee']}/>}></Route> 
              <Route path="scanstatus" element={<Scanstatus data={permissionSet['scanstatus']}/>}></Route> 
              <Route path="masterprofile" element={<MasterProfile data={permissionSet['masterprofile']} onShowChanged={handleShowChanged}/>}></Route> 
              <Route path="report" element={<Invoicereport data={permissionSet['statementreport']}/>}></Route>
              <Route path="invoicereport" element={<Invoicereportacc data={permissionSet['invoicereport']}/>}></Route> 
              <Route path="paymentreport" element={<Paymentreport data={permissionSet['paymentreport']}/>}></Route> 
              <Route path="expensereport" element={<Expensereport data={permissionSet['expensereport']}/>}></Route> 
            </Routes>
            <div style={{display:"none"}}><Scanstatus ref={handleScanStatusReload}/></div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}
export default Navbar;
